import React from "react";
import { Popup as DhxPopup } from "dhx-suite";

interface ShareWindowProps {
    url: string;
    visible: boolean;
    onCopyClick: () => void;
    onClose: () => void;
    darkMode: boolean;
}

export const ShareWindow = ({ url, visible, onCopyClick, onClose, darkMode }: ShareWindowProps) => {
    const winRef = React.useRef<DhxPopup>(new DhxPopup({
        css: "st-settings-popup dhx_widget--border-shadow"
    }));
    React.useEffect(() => {
        if (winRef.current) {
            winRef.current.attachHTML(`
            <div class="st_share-window" id="share_win">
                <div class="st_share-window--title">You can use the link below to share the code:</div>
                <div class="st_share-window--container">
                    <input readonly type="text" id="st_link_holder" value="${url}" class="st_share-window--link-input"></input>
                    <button id="st_copy_link" class="st_share-window--copy-button dhx_button dhx_button--color_primary dhx_button--size_small dhx_button--view_flat dhx_button--circle st_share-window--copy-button">
                        <span class="dhx_button__icon mdi mdi-folder"></span>
                        <span class="dhx_button__text">Copy</span>
                    </button>
                </div>
            </div>`);
        }
    }, []);

    React.useEffect(() => {
        if (winRef.current) {
            if (visible) {
                const btn = document.querySelector('[dhx_id="share"]')! as HTMLElement;
                winRef.current.show(btn);

                const linkHolder = document.querySelector("#st_link_holder")! as HTMLInputElement;
                const copyBtn = document.querySelector("#st_copy_link")! as HTMLElement;

                const shareWin = document.querySelector("#share_win")! as HTMLInputElement;
                if (darkMode) {
                    shareWin.classList.add("dark-theme");
                } else {
                    shareWin.classList.remove("dark-theme");
                }

                linkHolder.value = url;
                linkHolder.select();
                linkHolder.setSelectionRange(0, 99999);

                copyBtn.addEventListener("click", onCopyClick);

                winRef.current.events.on("afterHide", onClose);

                return () => {
                    copyBtn.removeEventListener("click", onCopyClick);
                };
            } else {
                winRef.current.hide();
            }
        }
        return undefined;
    }, [visible, url, darkMode]);
    return <></>;
};
